import axios from "axios";
// import store from "@/store";

const myAxios = axios.create({
  timeout: 5000,
});


// 请求拦截器
myAxios.interceptors.request.use(
  config => {
    // 为请求头挂载 Authorization 字段
    //  if (store.state.token) {
    //       config.headers.Authorization = store.state.token;
    //     }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
myAxios.interceptors.response.use(response => {
  // 响应状态码为 2xx 3xx 时触发成功的回调，形参中的 response 是“成功的结果”
  //return到axios原地Promise对象，作为成功的结果
  return response
}, error => {
  // 响应状态码不是 2xx 时触发失败的回调，形参中的 error 是“失败的结果”
  if (error.response.status === 401) {
    // 无效的 token 或token过期了
    // 把 Vuex 中的 token 重置为空，并跳转到登录页面
    // store.commit('updateToken', '')
    // router.push("/login");
  }

  return Promise.reject(error)
})

export default myAxios
